var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"cz2__btn cz2__cursor-pointer",class:[
        _vm.isMobile && _vm.isReview ? 'cz2__btn--flat' : 'cz2__btn--black',
    ]},[_vm._v(" "+_vm._s(_vm.buttonCopy)+" "),(_vm.aiActiveState === _vm.aiStates.default)?_c('beta-badge',{attrs:{"is-in-button":true}}):_vm._e(),_c('input',{staticClass:"hide",attrs:{"name":"aiUpload","type":"file","accept":_vm.fileTypes},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }